import copy from 'copy-to-clipboard'
import { browserVersion, isChrome, isDesktop, isMobile } from 'react-device-detect'
import message from 'antd/lib/message'
import isEqual from 'lodash/isEqual'

const VALID_CHROME_VERSION = 80

const isSupportedBrowser =
  isChrome && isDesktop ? Number(browserVersion) >= VALID_CHROME_VERSION : true

const copyLinkToClipboard = (url, successMessage = 'Link copied successfully') => {
  const copyToClipboard = () => {
    copy(url)
    message.success(successMessage, 2.5)
  }

  if (isMobile && navigator.share) {
    navigator
      .share({
        title: 'Teleport',
        url,
      })
      .catch(copyToClipboard)
  } else {
    copyToClipboard()
  }
}

const objectDiff = (source, comparator = {}) =>
  Object.keys(source).reduce((difference, key) => {
    if (!isEqual(source[key], comparator[key])) {
      difference[key] = source[key]
    }
    return difference
  }, {})

const parseUserToVideoAskContact = user => ({
  contact_name: user.name,
  contact_user_id: user.id,
  contact_email: encodeURIComponent(user.email),
  contact_phone_number: encodeURIComponent(user.phoneNumber),
})

const getSocialHandle = link => {
  if (link) {
    const idx = link.lastIndexOf('/')
    return `${link.substring(idx + 1).replace('@', '')}`
  }

  return ''
}

export {
  isSupportedBrowser,
  copyLinkToClipboard,
  objectDiff,
  parseUserToVideoAskContact,
  getSocialHandle,
}
